/**
 * Shopify Native Analytics Integration Helper
 * Simplified to use only Shopify's native Customer Events API
 */

window.ShopifyAnalyticsHelper = {
  
  /**
   * Initialize analytics helper
   */
  init: function() {
    console.log('🚀 Shopify Analytics Helper initializing...');
    console.log('✅ Shopify Analytics Helper ready - using native Customer Events API only');
    return this;
  },
  
  /**
   * Track product added to cart
   * @param {Object} product - Product data
   * @param {number} quantity - Quantity added
   */  trackAddToCart: function(product, quantity = 1) {
    // Use only native Shopify Customer Events API
    if (window.Shopify?.customerEvents?.publish) {
      try {
        window.Shopify.customerEvents.publish('cart_line_added', {
          productVariantId: product.variant_id,
          quantity: quantity
        });
        console.log('✅ Shopify Customer Events: cart_line_added');
      } catch (error) {
        console.error('❌ Shopify Customer Events error:', error);
      }
    }
  },
  
  /**
   * Track cart viewed
   */  trackCartView: function() {
    // Use only native Shopify Customer Events API
    if (window.Shopify?.customerEvents?.publish) {
      try {
        window.Shopify.customerEvents.publish('cart_viewed', {
          currency: window.Shopify?.currency?.active || 'USD'
        });
        console.log('✅ Shopify Customer Events: cart_viewed');
      } catch (error) {
        console.error('❌ Shopify Customer Events error:', error);
      }
    }
  },
  
  /**
   * Track product removed from cart
   * @param {Object} product - Product data (optional, may not be available)
   * @param {number} quantity - Quantity removed
   */  trackRemoveFromCart: function(product = null, quantity = 1) {
    // Use only native Shopify Customer Events API
    if (window.Shopify?.customerEvents?.publish) {
      try {
        const eventData = { quantity: quantity };
        if (product) {
          eventData.productVariantId = product.variant_id;
        }
        
        window.Shopify.customerEvents.publish('cart_line_removed', eventData);
        console.log('✅ Shopify Customer Events: cart_line_removed');
      } catch (error) {
        console.error('❌ Shopify Customer Events error:', error);
      }
    }
  },
  
  /**
   * Track checkout started
   * @param {Object} cartData - Cart data
   */  trackCheckoutStarted: function(cartData) {
    // Use only native Shopify Customer Events API
    if (window.Shopify?.customerEvents?.publish) {
      try {
        window.Shopify.customerEvents.publish('checkout_started', {
          currency: window.Shopify?.currency?.active || 'USD',
          value: cartData.total_price / 100
        });
        console.log('✅ Shopify Customer Events: checkout_started');
      } catch (error) {
        console.error('❌ Shopify Customer Events error:', error);
      }
    }
  },
  
  /**
   * Custom event tracking (for theme-specific events)
   * @param {string} eventName 
   * @param {Object} eventData 
   */  trackCustomEvent: function(eventName, eventData) {
    // Use only native Shopify Customer Events API
    if (window.Shopify?.customerEvents?.publish) {
      try {
        window.Shopify.customerEvents.publish(eventName, eventData);
        console.log('✅ Shopify Customer Events:', eventName);
      } catch (error) {
        console.error('❌ Shopify Customer Events error:', error);
      }
    }
  }
};

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.ShopifyAnalyticsHelper.init();
});
